import Page from "webPage/Page";
import Gallery from "base/Gallery";

Page.register(new RegExp('/news-and-events/([0-9a-z\-]+)/?'), () => {
    new Gallery($(".js-gallery"), {
        itemClass: "slider__image",
        pipClass: "slider__slide-icon",
    });


    $(window).on("scroll resize", () => {
        let $sticky = $(".js-sticky-share");
        if ($(window).outerWidth() < 760) {
            $sticky.removeClass("social-media--sticky social-media--sticky-bottom").css("top", "");
            return;
        }
        let $header = $(".header");

        let headerHeight = $header.position().top + $header.outerHeight();
        let scrollTop = $(window).scrollTop() + headerHeight;
        let scrollBottom = scrollTop + $sticky.outerHeight();
        let top = $sticky.parent().offset().top;
        let bottom = top + $sticky.parent().height();

        if (scrollTop <= top) {
            $sticky.removeClass("social-media--sticky social-media--sticky-bottom").css("top", "");
        } else if (scrollBottom >= bottom) {
            $sticky.removeClass("social-media--sticky").addClass("social-media--sticky-bottom").css("top", "");
        } else {
            $sticky.removeClass("social-media--sticky-bottom").addClass("social-media--sticky").css("top", headerHeight);
        }
    });
});
